<div *ngIf="!IsViewOrder">
    <mat-tab-group (selectedTabChange)="tabClick($event)">
        <mat-tab label="{{ 'InProgress' | translate }}" *ngIf="IsMyOrders||IsSaved">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-content>
                    <app-order-list [AllInvoices]="AllProgressInvoices"
                        (newItemEvent)="GetData($event)"></app-order-list>
                </mat-card-content>
            </mat-card>
        </mat-tab>

        <mat-tab label="{{ 'Incoming' | translate }}" *ngIf="IsMyOrders||IsSaved">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-content>
                    <app-order-list [AllInvoices]="AlRecivedInvoices" (newItemEvent)="GetData($event)"></app-order-list>
                </mat-card-content>
            </mat-card>
        </mat-tab>

        <mat-tab label="{{ 'Recived' | translate }}" *ngIf="!IsMyOrders&&!IsSaved">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-content>
                    <app-order-list [AllInvoices]="AlRecivedInvoices" (newItemEvent)="GetData($event)"></app-order-list>
                </mat-card-content>
            </mat-card>
        </mat-tab>

        <mat-tab label="{{ 'Rejected' | translate }}">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-content>
                    <app-order-list [AllInvoices]="AlRejectedInvoices"
                        (newItemEvent)="GetData($event)"></app-order-list>
                </mat-card-content>
            </mat-card>
        </mat-tab>
    </mat-tab-group>
</div>

<div *ngIf="IsViewOrder">
    <app-view-order [totalOrderCost]="totalOrderCost" (IsIsViewOrder)="CheckIsIsViewOrder($event)">
    </app-view-order>
</div>